import React, { FC, useEffect, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import pdfjsWorker from 'react-pdf/dist/esm/pdf.worker.entry'
import ErrorBoundary from '../../components/ErrorBoundary'
import { useMultipleLocalizedText } from '../../contexts/Localization/localizationHooks'
import downloadFileFromBase64 from '../../utils/downloadFile'

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker

interface CertificateContainerProps {
    certificateFile: string
    certificateFileName: string
    registerDownload: (callback: Function) => void
}
export const CertificateContainer: FC<CertificateContainerProps> = ({
    certificateFile,
    certificateFileName,
    registerDownload
}) => {
    const {
        NATIVE_ESIG_RENDER_ERROR,
    } = useMultipleLocalizedText()
    const [numPages, setNumPages] = useState(0);

    const handleLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages);
    }

    const handleDownloadCertificate = async () => {
        downloadFileFromBase64(certificateFile, certificateFileName);
    }

    useEffect(() => {
        registerDownload(handleDownloadCertificate)
    }, [])

    return (
        <ErrorBoundary text={NATIVE_ESIG_RENDER_ERROR}>
            <Document
                file={certificateFile}
                options={{ isEvalSupported: false }}
                onLoadSuccess={handleLoadSuccess}>
                {new Array(numPages).fill('').map((_, i) => (
                    <>
                        <Page pageNumber={i + 1} renderTextLayer={false} renderMode='svg' />
                        {numPages > 1 && <div><p>{i + 1}/{numPages}</p><hr/></div>}
                    </>
                ))}
            </Document>
        </ErrorBoundary>
    )
}
export default CertificateContainer
